// extracted by mini-css-extract-plugin
module.exports = {"contentSection":"Owners_contentSection__1UBYd","content":"Owners_content__2pF5v","title":"Owners_title__2wSCL","pagination":"Owners_pagination__3grpJ"};